import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AccountDao } from '@app/dao/account/account.dao';
import { OptimizationDao } from '@app/dao/optimization/optimization.dao';
import { Subject, tap } from 'rxjs';
import { fiscalityLabel } from '@app/dashboard/shared/fiscality-rent/fiscality-rent-columns';
import { EaOptimizationFiscalityRentFormBuilder } from './ea-optimization-fiscality-rent-form.builder';

@Component({
    selector: 'ea-optimization-fiscality-rent-form',
    templateUrl: './ea-optimization-fiscality-rent-form.component.html',
    styleUrls: ['./ea-optimization-fiscality-rent-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaOptimizationFiscalityRentFormComponent),
        },
    ],
    standalone: false
})
export class EaOptimizationFiscalityRentFormComponent
  extends EaOptimizationFiscalityRentFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  account: any;
  fiscalityType: [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private accountDao: AccountDao,
    private optimizationDao: OptimizationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.accountDao.getAccount().subscribe(account => {
      this.account = account;
    });
    this.fiscalityType = this.options.map(o => o.type);
  }

  onSubmit() {
    this.prFormService.loading();
    let dto = {
      type: 'FISCALITY_RENT',
      input: { ...this.entity, ...this.extract() },
    };
    this.optimizationDao.optimizeFiscalityRent(this.account.id, dto).subscribe(
      optimization => {
        this.prFormService.loaded();
        if (!optimization)
          return this.notificationService.warn(
            'Aucune optimisation pour cette configuration.',
          );
        this.callback(optimization);
        this.notificationService.success('La sauvegarde a réussi');
        this.doneSubject.next();
      },
      errors => {
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
      },
    );
  }

  fiscalityLabel(type: string) {
    return fiscalityLabel(type);
  }

  get inCash() {
    return this.form.get('cashOrCredit').value == 'CASH';
  }
}
